import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Classes from '@/pages/home/components/Classes';

export default function ClassesPage() {
  return (
    <div className="min-h-screen bg-black">
      <Helmet>
        <title>Classes at HUB30 | CrossFit, Calisthenics & More – Jbeil, Lebanon</title>
        <meta
          name="description"
          content="Explore all training classes at HUB30 gym in Jbeil — CrossFit, calisthenics, mobility, and kids classes. Multiple levels, flexible schedules, expert coaches."
        />
        <meta
          name="keywords"
          content="CrossFit classes Jbeil, calisthenics classes Lebanon, kids gym class Lebanon, mobility class Jbeil, fitness classes Byblos"
        />
        <link rel="canonical" href="https://hub30gym.com/classes" />
        <meta property="og:title" content="Classes at HUB30 | CrossFit, Calisthenics & More – Jbeil" />
        <meta property="og:description" content="Explore all training classes at HUB30 gym in Jbeil — CrossFit, calisthenics, mobility, and kids classes." />
        <meta property="og:url" content="https://hub30gym.com/classes" />
      </Helmet>
      <Navbar />
      <div className="pt-20">
        <Classes />
      </div>
      <Footer />
    </div>
  );
}
